<template>
  <el-dialog
    :close-on-click-modal="false"
    title="新增"
    :visible.sync="addEvaluationProjectFormVisible"
    class="large-dialog pr-10px"
    v-dialogDrag
    @close="cancelAdd"
  >
    <el-form :model="addEvaluationProjectForm" ref="aptitudeForm" label-width="150px" inline>
      <el-form-item label="" prop="">
        <select-tree
          v-model="addEvaluationProjectForm.safetyEvaluationIndexId"
          :optionList="treeData"
          :treeProps="{
            label: 'name',
            children: 'childs',
          }"
          placeholder="请选择关联项目"
          class="w-full"
          @treeNodeClick="treeNodeClick"
        />
      </el-form-item>
      <el-form-item label="" prop="">
        <el-input
          placeholder="请输入"
          v-model="addEvaluationProjectForm.project"
          size="small"
          class="mr-10px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item prop="">
        <el-button size="small" type="primary" @click="searchList">搜索</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableList"
      border
      class="w-full"
      :height="tableHeight"
      stripe
      v-loading="loading"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" :selectable="isRowSelectable"></el-table-column>
      <el-table-column label="序号" type="index" width="100"></el-table-column>
      <el-table-column
        label="评价项目"
        prop="project"
        width="280"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="评价内容"
        width="580"
        prop="content"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="标准分"
        width="180"
        prop="standardScore"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="评分标准"
        width="490"
        prop="scoringStandar"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <div class="text-right mt-20px ml-10px">
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="total"
      ></el-pagination>
    </div>
    <div>
      <span>关联模块：</span>
      <el-select
        ref="menuTreeRef"
        value-key="Id"
        clearable
        filterable
        @clear="clearRelationModule"
        v-model="relationModule"
        placeholder="请选择"
        :loading="menuTreeLoading"
      >
        <el-tree
          :props="{
            label: 'Name',
            children: '_Child',
          }"
          node-key="Id"
          highlight-current
          :data="menuTreeData"
          @node-click="menuTreeNodeClick"
          :expand-on-click-node="false"
        ></el-tree>
        <el-option
          v-for="item in flatTreeData"
          :key="item.Id"
          :value="item.Url"
          :label="item.Name"
          class="hidden"
        ></el-option>
      </el-select>
    </div>
    <div slot="footer" class="dialog-footer flex justify-center items-center">
      <el-button
        size="small"
        type="primary"
        icon="iconfont icon-save"
        @click="saveAddEvaluationProject"
        >保存</el-button
      >
      <el-button size="small" icon="iconfont icon-close" @click="cancelAdd">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  SafetyEvaluationApi,
  SafetyEvaluationIndexApi,
} from '@wiz-api/safety-evaluation-management'

const SelectTree = () => {
  return import('@/components/safety/FormSelect/SelectTree')
}
const safetyEvaluationApi = new SafetyEvaluationApi()
const safetyEvaluationIndexApi = new SafetyEvaluationIndexApi()
export default {
  components: {
    SelectTree,
  },
  model: {
    prop: 'addEvaluationProjectFormVisible',
    event: 'addEvaluationProjectFormChange',
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 178px)'
    },
  },
  props: {
    addEvaluationProjectFormVisible: {
      type: Boolean,
      default: false,
    },
    treeData: {
      type: Array,
      default: () => {
        return []
      },
    },
    currentTreeSelect: {
      type: Object,
      default: () => {},
    },
    projectDataList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      saveProjectDataListId: [],
      loading: false,
      total: 0,
      pageNo: 1,
      pageSize: 15,
      tableList: [],
      addEvaluationProjectForm: {
        safetyEvaluationIndexId: '',
      },
      defaultExpandedKeys: [],
      searchData: {},
      recordName: '',
      currentNode: {},
      selectEvaluation: [],
      saveParentId: '',
      relationModule: null, // 关联模块
      menuTreeData: [], // 菜单目录树列表数据
      flatTreeData: [], // 扁平化菜单列表数据
      menuTreeLoading: false, // 菜单目录树列表数据加载loading
    }
  },
  watch: {
    addEvaluationProjectFormVisible(val) {
      if (val) {
        this.findList()
      }
    },
    currentTreeSelect(val) {
      if (val) {
        this.addEvaluationProjectForm.safetyEvaluationIndexId = val.id

        this.recordName = val.name || val.chapter
        this.getProjectList(val.saveParentId)
        this.saveParentId = val.saveParentId
      }
    },
  },
  methods: {
    /**
     * @description 获取菜单目录树
     */
    async getMenuTree() {
      if (!window.__POWERED_BY_QIANKUN__) return
      const formData = new FormData()
      formData.append('TableName', 'Sys_Menu')
      formData.append('_PageIndex', 1)
      formData.append('_PageSize', 999)
      const instance = axios.create()
      instance.defaults.baseURL = localStorage.getItem('DiyApiBase')
      const token = localStorage.getItem('authorization')
      instance.defaults.headers.common.Authorization = `Bearer ${token}`
      this.menuTreeLoading = true
      const res = await instance.post('/api/diytable/getDiyTableRowTree', formData)
      if (res.status === 200 && res.data?.Code === 1) {
        this.menuTreeData = res.data.Data
        this.flatTreeData = this.transformList([...res.data.Data])
      }
      this.menuTreeLoading = false
    },

    /**
     * @description 清空关联模块筛选
     */
    clearRelationModule() {
      this.relationModule = null
    },

    /**
     * @description 关联模块目录树下拉框点选
     */
    menuTreeNodeClick(node) {
      if (node._Child) return
      this.relationModule = node.Url
      this.$refs.menuTreeRef.blur()
    },

    /**
     * @description 菜单目录树数据扁平化
     */
    transformList(data, resultList = []) {
      if (!Array.isArray(data)) {
        return []
      }
      data.forEach((node) => {
        resultList.push({ ...node })
        this.transformList(node._Child, resultList)
      })
      return resultList
    },

    isRowSelectable(row) {
      return !this.saveProjectDataListId.includes(row.id)
    },
    handleSelectionChange(val) {
      this.selectEvaluation = val.map((item) => {
        return item.id
      })
    },
    treeNodeClick(node) {
      this.saveParentId = node.saveParentId
      this.getProjectList(node.saveParentId)
    },
    clearSelect() {
      this.recordName = ''
      this.currentNode = {}
    },
    async getProjectList(id) {
      const data = {
        maxResultCount: 999, // 每页多少条
        skipCount: 0, // 跳过多少条
        safetyEvaluationIndexId: id, // 目录id
      }
      const [err, res] = await safetyEvaluationIndexApi.getSafetyEvaluationIndexPageList(data)
      if (!err) {
        this.saveProjectDataListId = res.items.map((item) => {
          return item.id
        })
      }
    },
    recordSelectChange(boolean) {
      this.$nextTick(() => {
        if (boolean) {
          this.$refs.recordTreeRef.setCurrentKey(
            this.addEvaluationProjectForm.safetyEvaluationIndexId
          ) // 设置选中元素
          this.defaultExpandedKeys = [this.addEvaluationProjectForm.safetyEvaluationIndexId]
          this.saveProjectDataListId = []
        } else {
          const nodeDatas = this.$refs.recordTreeRef.store.nodesMap
          _.forIn(nodeDatas, (val) => {
            val.expanded = false
          })
        }
      })
    },
    async saveAddEvaluationProject() {
      if (this.selectEvaluation.length === 0) {
        this.$message.error('请选择评价项目')
        return
      }
      const [err, res] = await safetyEvaluationIndexApi.bindSafetyEvaluation({
        body: {
          safetyEvaluationIndexId: this.addEvaluationProjectForm.safetyEvaluationIndexId,
          safetyEvaluations: this.selectEvaluation,
          relationModule: this.relationModule,
        },
      })
      if (!err) {
        this.$message.success('新增成功')
        this.cancelAdd()
      }
    },
    cancelAdd() {
      this.addEvaluationProjectForm = {}
      this.$emit('addEvaluationProjectFormChange', false)
    },
    resetSearch() {
      this.addEvaluationProjectForm.project = ''
      this.searchList()
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    async findList() {
      this.loading = true
      const [err, res] = await safetyEvaluationApi.getPgeList({
        project: this.addEvaluationProjectForm.project,
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
      })
      this.loading = false
      if (!err) {
        this.tableList = res.items
        this.total = res.totalCount
      }
    },
  },
  created() {
    this.getMenuTree()
  },
}
</script>
